import { get, post } from '../common'
import COS from './cos'

type ApiResponse<T> = ApiTypes.ApiResponse<T>
type ApiResponsePageList<T> = ApiTypes.ApiResponsePageList<T>

export namespace admin {
  export const cos = COS

  //#region 登录
  // 登录
  export function login(data: PostData.Admin.Login) {
    return post<ApiResponse<ServerData.Admin.Login>>('/admin/login', {}, data)
  }

  // 获取用户信息
  export function getUserInfo() {
    return get<ApiResponse<ServerData.Admin.UserInfo>>('/admin/user_info', {})
  }
  //#endregion

  //#region 课程基础属性

  // 课件属性列表
  export function getAllCourseBaseAttrList() {
    return get<ApiResponse<{ name: string; type: string }[]>>('/admin/goods_attr/all_list', {})
  }

  // 属性列表
  export function getCourseBaseAttr(type: string) {
    return get<ApiResponse<ServerData.Admin.CourseAttr[]>>('/admin/goods_attr/list', { type })
  }

  // 新增属性
  export function addGoodsAttr(data: { type: string; code: string; name: string; sort?: number }) {
    return post<ApiResponse<boolean>>('/admin/goods_attr/add', {}, data)
  }

  // 修改属性
  export function updGoodsAttr(data: { type: string; code: string; name: string; sort?: number }) {
    return post<ApiResponse<boolean>>('/admin/goods_attr/update', {}, data)
  }

  // 删除属性
  export function delCourseBaseAttr(type: string, code: string) {
    return post<ApiResponse<boolean>>('/admin/goods_attr/delete', {}, { type, code })
  }

  //#endregion

  //#region 课件

  // 获取课件列表
  export function getCourseList(params: PostData.Admin.CourseListParams) {
    return get<ApiResponsePageList<ServerData.Admin.CourseListItem>>('/admin/goods/list', { ...params })
  }

  // 新增课件
  export function addCourse(data: PostData.Admin.AddCourse) {
    return post<ApiResponse<boolean>>('/admin/goods/add', {}, data)
  }

  // 更新课件
  export function updateCourse(data: PostData.Admin.UpdateCourse) {
    return post<ApiResponse<boolean>>('/admin/goods/update', {}, data)
  }

  // 获取课件详情
  export function getCourseDetail(goodsId: string) {
    return get<ApiResponse<ServerData.Admin.CourseDetail>>('/admin/goods/detail', { goodsId })
  }

  // 删除课件
  export function deleteCourse(goodsId: string) {
    return post<ApiResponse<boolean>>('/admin/goods/delete', {}, { goodsId })
  }

  // 获取课件已关联的系列课列表
  export function getCourseBelongsToSeries(goodsId: string) {
    return get<ApiResponse<Array<{ goodsId: number; goodsImg: string; goodsName: string; id: number }>>>('/admin/goods/belongs_to_series', { goodsId })
  }

  // 获取系列课列表（含章节）
  export function getSeriesWithChapters(params: { pageIndex: number; pageSize: number; goodsName?: string }) {
    return get<ApiResponse<{ list: Array<{
      attachCount: number;
      goodsId: number;
      goodsImg: string;
      goodsName: string;
      priceLow: number;
      saleStatus: number;
      units: Array<{
        chapterTitle: string;
        id: number;
      }>;
    }>; total: number }>>('/admin/goods/series_with_chapters', params)
  }

  // 移除课件已关联的系列课
  export function removeCourseBelongsToSeries(id: number) {
    return post<ApiResponse<boolean>>('/admin/goods/belongs_to_series_remove', {}, { id })
  }

  // 添加课件关联到系列课
  export function addCourseBelongsToSeries(data: { goodsId: string; seriesId: string; chapterId?: string | number }) {
    return post<ApiResponse<boolean>>('/admin/goods/belongs_to_series_add', {}, data)
  }

   // 更新单课件状态
   export function updateCourseSaleStatus(goodsIdList: string[], saleStatus: number) {
    return post<ApiResponse<boolean>>('/admin/goods/update_sale_status', {}, { goodsIdList, saleStatus })
  }
  // 更新课件状态
  export function updateCourserieseSaleStatus(goodsIdList: string[], saleStatus: number) {
    return post<ApiResponse<boolean>>('/admin/course_relation/update_sale_status', {}, { goodsIdList, saleStatus })
  }
  //#endregion

  //#region 系列课

  // 获取系列课列表
  export function getSeriesCourseList(params: PostData.Admin.SeriesCourseListParams) {
    return get<ApiResponsePageList<ServerData.Admin.SeriesCourseListItem>>('/admin/course_relation/list', { ...params })
  }

  // 获取系列课详情
  export function getSeriesCourseDetail(goodsId: string) {
    return get<ApiResponse<ServerData.Admin.SeriesCourseDetail>>('/admin/course_relation/detail', { goodsId })
  }

  // 更新系列课
  export function updateSeriesCourse(data: PostData.Admin.UpdateSeriesCourse) {
    return post<ApiResponse<boolean>>('/admin/course_relation/update', {}, data)
  }

  // 新增系列课
  export function addSeriesCourse(data: PostData.Admin.AddSeriesCourse) {
    return post<ApiResponse<boolean>>('/admin/course_relation/add', {}, data)
  }

  // 删除系列课
  export function deleteSeriesCourse(goodsId: string) {
    return post<ApiResponse<boolean>>('/admin/course_relation/delete', {},{ goodsId })
  }

  // 更新系列课状态
  export function updateSeriesCourseSaleStatus(goodsIdList: string[], saleStatus: number) {
    return post<ApiResponse<boolean>>('/admin/course_relation/update_sale_status', {}, { goodsIdList, saleStatus })
  }

  // 获取系列课关联系列课
  export function getSeriesCourseRelationList(goodsId: string) {
    return get<ApiResponse<ServerData.Admin.SeriesCourseRelationItem[]>>('/admin/course_relation/children/list', {
      goodsId,
    })
  }

    // 获取系列课关联系列课
  export function getSeriesCourseRelationListNew(goodsId: string) {
    return get<ApiResponse<ServerData.Admin.SeriesCourseRelationItem[]>>('/admin/course_relation/get_packet_list', {
      goodsId,
    })
  }

  // 更新系列课关联系列课
  export function updateSeriesCourseRelation(data: { goodsId: string; children: string[] }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/children/update', {}, data)
  }
  //  // 更新系列课关联系列课
   export function updateSeriesCourseRelationSort(data: { goodsId: string; sortList: string[] }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/children/sort', {}, data)
  }

  // 获取系列课章节列表
  export function getSeriesCourseChapter(goodsId: string,type?:string) {
    return get<ApiResponse<ServerData.Admin.SeriesCourseChapterItem[]>>('/admin/course_relation/chapter/list', {
      goodsId,
      type
    })
  }

  //系列课中新增一个章节
  export function addSeriesCourseChapter(data: { goodsId: string; chapterTitle: string,type?:string }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/add', {}, data)
  }

  //系列课中修改一个章节
  export function updateSeriesCourseChapter(data: { chapterId: string; chapterTitle: string }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/update', {}, data)
  }

  //系列课中删除一个章节
  export function deleteSeriesCourseChapter(data: { goodsId: string; chapterIdList: string[],type?:string }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/delete', {}, data)
  }
  // 设为最近更新、取消最近更新
  // /admin/course_relation/chapter/recent_update
  export function cancelSeriesCourseChapterRecentUpdate(data: { chapter_id: string; operation:string }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/recent_update', {}, data)
  }
  //批量新增/删除单课件关联
  export function updateSeriesCourseChapterGoods(data: { goodsId: string; chapterId?: string; goodsIdList: string[],type?:string }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/goods/update', {}, data)
  }

  //批量更新系列课价格
  export function updateSeriesCourseChapterGoodsPrice(data: { goodsId: string; priceLow: number }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/batch_update_price', {}, data)
  }

  // 更新系列课章节排序
  export function updateSeriesCourseChapterSort(data: PostData.Admin.UpdateSeriesCourseChapterSort) {
    return post<ApiResponse<boolean>>('/admin/course_relation/chapter/goods/sort', {}, data)
  }

  // 系列课下批量新增/删除子系列课
  export function addSeriesCourseRelation(data: { goodsId: string; children: string[] }) {
    return post<ApiResponse<boolean>>('/admin/course_relation/children/update', {}, data)
  }
  // 获取特殊系列课列表
  export function getSpecialSeriesCourseList(params: PostData.Admin.SpecialSeriesCourseListParams) {
    return get<ApiResponsePageList<ServerData.Admin.SeriesCourseListItem>>(
      '/admin/special_course_relation/list',
      { ...params },
    )
  }

  // 获取特殊系列课详情
  export function getSpecialSeriesCourseDetail(goodsId: string) {
    return get<ApiResponse<ServerData.Admin.SpecialCourseDetail>>('/admin/special_course_relation/detail', {
      goodsId,
    })
  }

  // 新增特殊系列课
  export function addSpecialSeriesCourse(data: Partial<PostData.Admin.AddSpecialSeriesCourse>) {
    return post<ApiResponse<boolean>>('/admin/special_course_relation/add', {}, data)
  }

  // 更新特殊系列课
  export function updateSpecialSeriesCourse(data:Partial<PostData.Admin.UpdateSeriesCourse>) {
    return post<ApiResponse<boolean>>('/admin/special_course_relation/update', {}, data)
  }

  // 删除特殊系列课
  export function deleteSpecialSeriesCourse(goodsId: string) {
    return post<ApiResponse<boolean>>('/admin/special_course_relation/delete',{}, { goodsId })
  }

  // 更新特殊系列课状态
  export function updateSpecialSeriesCourseSaleStatus(goodsIdList: string[], saleStatus: number,type?:string) {
    return post<ApiResponse<boolean>>('/admin/special_course_relation/update_sale_status', {}, {
      goodsIdList,
      saleStatus,
      type
    })
  }

  //#endregion

  //#region 权限管理

  // 获取角色列表
  export function getRoleList(params: { pageIndex: number; pageSize: number; name?: string }) {
    return get<ApiResponsePageList<ServerData.Admin.RoleItem>>('/admin/roles', { ...params })
  }

  // 获取角色详情
  export function getRoleDetail(id: string) {
    return get<ApiResponse<ServerData.Admin.RoleItem>>('/admin/roles/detail', { roleId:id })
  }

  // 新增角色
  export function addRole(data: ServerData.Admin.RoleFormData) {
    return post<ApiResponse<boolean>>('/admin/roles/add', {}, data)
  }

  // 更新角色
  export function updateRole(id: string, data: ServerData.Admin.RoleFormData) {
    return post<ApiResponse<boolean>>('/admin/roles/update', {}, { ...data, roleId: id })
  }

  // 删除角色
  export function deleteRole(id: string) {
    return post<ApiResponse<boolean>>('/admin/roles/delete', {}, { roleId: id })
  }

  // 获取权限系统
  export function getMenuTree() {
    return get<ApiResponsePageList<ServerData.Admin.PermissionItem>>('/admin/permissions', {})
  }

  // 获取角色绑定的菜单
  export function getRoleMenus(roleId: string) {
    return get<ApiResponse<string[]>>('/admin/roles/detail', { roleId })
  }

  // 绑定菜单到角色
  export function bindRoleMenus(roleId: string, permissionIds: Record<string, string>) {
    return post<ApiResponse<boolean>>('/admin/roles/assign-permissions', {}, { roleId,permissions: permissionIds })
  }

   export function bindUser(roleId: string, userId: number|undefined) {
    return post<ApiResponse<boolean>>('/admin/admin_users/assign-role', {}, { roleId,userId })
  }

  //#endregion

  //#region 用户管理

  // 获取用户列表
  export function getAdminUserList(params: { pageIndex: number; pageSize: number; username?: string }) {
    return get<ApiResponsePageList<ServerData.Admin.AdminUserItem>>('/admin/admin_users', { ...params })
  }

  // 获取用户详情
  export function getAdminUserDetail(id: number) {
    return get<ApiResponse<ServerData.Admin.AdminUserItem>>('/admin/admin_users/detail', { id })
  }

  // 新增用户
  export function addAdminUser(data: ServerData.Admin.AdminUserFormData) {
    return post<ApiResponse<boolean>>('/admin/admin_users/add', {}, data)
  }

  // 更新用户
  export function updateAdminUser(id: number, data: ServerData.Admin.AdminUserFormData & { password?: string }) {
    return post<ApiResponse<boolean>>('/admin/admin_users/update', {}, { ...data,userId:id })
  }

  // 删除用户
  export function deleteAdminUser(id: number) {
    return post<ApiResponse<boolean>>('/admin/admin_users/delete', {}, { userId:id })
  }

  // 退出登录
  export function logout() {
    return post<ApiResponse<void>>('/admin/logout', {})
  }

  //#endregion

  //#region 前台用户管理

  // 获取前台用户列表
  export function getFrontUserList(params: { 
    pageIndex: number
    pageSize: number
    inviteCode?: string
    createdAtStart?: string
    createdAtEnd?: string
  }) {
    return get<ApiResponsePageList<ServerData.Admin.FrontUserItem>>('/admin/users/list', { ...params })
  }

  // 获取前台用户详情
  export function getFrontUserDetail(inviteCode: number|string) {
    return get<ApiResponse<ServerData.Admin.FrontUserDetail>>('/admin/users/detail', { userId: inviteCode })
  }

  // 获取用户购买记录
  export function getUserVipRecordList(params: { pageIndex: number; pageSize: number; userId?: string }) {
    return get<ApiResponsePageList<ServerData.Admin.UserVipRecordItem>>('/admin/user_vip_record/list', { ...params })
  }

  // 获取用户下载记录
  export function getUserDownloadRecordList(params: { pageIndex: number; pageSize: number; userId?: string }) {
    return get<ApiResponsePageList<ServerData.Admin.UserDownloadRecordItem>>('/admin/user_download_record/list', { ...params })
  }

  // 开通权益
  export function addUserVipRecord(data: {
    user_id: number
    goods_id: string
    goods_type: number
    days: number
  }) {
    return post<ApiResponse<boolean>>('/admin/users/add_vip_record', {}, data)
  }

   // 取消权益
  export function deleteUserVipRecord(data: {
    user_id: number|undefined
    id: number
  }) {
    return post<ApiResponse<boolean>>('/admin/users/delete_vip_record', {}, data)
  }
  //#endregion

  //#region 优惠券管理

  // 获取优惠券列表
  export function getCouponList(params: PostData.Admin.CouponListParams) {
    return get<ApiResponsePageList<DataModels.Coupon.CouponItem>>('/admin/coupon/list', { ...params })
  }

  // 获取优惠券详情
  export function getCouponDetail(couponId: number) {
    return get<ApiResponse<DataModels.Coupon.CouponDetail>>('/admin/coupon/detail', { couponId })
  }

  // 删除优惠券
  export function deleteCoupon(couponId: number) {
    return post<ApiResponse<null>>('/admin/coupon/delete', {},{ couponId })
  }

  // 创建优惠券
  export function createCoupon(data: PostData.Admin.CreateCouponParams) {
    return post<ApiResponse<{ couponId: number }>>('/admin/coupon/add',{}, {...data})
  }

  // 更新优惠券
  export function updateCoupon(data: PostData.Admin.UpdateCouponParams) {
    return post<ApiResponse<null>>('/admin/coupon/update', {},{...data} )
  }

  //#endregion
}
